/* import __COLOCATED_TEMPLATE__ from './priority-changed-by-workflow.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import {
  truncateEventText,
  isEventTextTruncated,
  KILLSWITCH_FLAG_NAME,
} from 'embercom/lib/inbox2/event-text-truncation';

interface Signature {
  Args: any;
}

export default class PriorityChangedByWorkflowComponent extends Component<Signature> {
  @service declare session: Session;

  get isConversationEventsUiImprovementsEnabled(): boolean {
    return !this.session.workspace?.isFeatureEnabled(KILLSWITCH_FLAG_NAME);
  }

  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::PriorityChangedByWorkflow': typeof PriorityChangedByWorkflowComponent;
    'inbox2/conversation-stream/event-parts/priority-changed-by-workflow': typeof PriorityChangedByWorkflowComponent;
  }
}
